module.exports = __webpack_public_path__ + "img/num_38.d2777d5c.png";